export default "__VITE_ASSET__7074fe3a__"